<template>
	<a-modal
		class="g-image-trio-edit-modal"
		:visible="visible"
		title="模块编辑"
		width="740px"
		:centered="true"
		:mask-closable="false"
		:destroy-on-close="true"
		@cancel="onCancel"
	>
		<div class="g-edit-modal__scroll">
			<div class="g-image-trio-edit" @click="clearSelection">
				<div
					class="g-image-trio-edit__stage"
				>
					<div
						ref="editGrid"
						class="g-image-trio-edit__grid"
						:style="gridStyle"
					>
						<div
							class="g-image-trio-edit__cell-wrap g-image-trio-edit__cell-wrap--main"
							:class="{ 'is-active': selectedIndex === 0 }"
							@click.stop="selectItem(0)"
						>
							<div
								class="g-image-trio-edit__cell"
								:class="{ 'is-selected': selectedIndex === 0 }"
								:style="cellStyle"
							>
								<UploadProgressPanel
									v-if="isUploading && selectedIndex === 0"
									:tasks="uploadTasks"
									variant="item"
									hide-filename
								/>
								<template v-else>
									<img v-if="getImageUrl(form.items[0])" :src="getImageUrl(form.items[0])" alt="" />
									<i v-else class="mbm-iconfont mbm-tupian"></i>
								</template>
								<input
									v-model="form.items[0].title"
									type="text"
									class="g-image-trio-edit__caption-input g-image-trio-edit__caption-input--main"
									:style="{ color: form.items[0].titleColor }"
									maxlength="20"
									placeholder="标题"
									@click.stop="selectItem(0)"
									@focus="selectItem(0)"
								/>
							</div>
							<div
								v-if="selectedIndex === 0"
								class="g-image-trio-edit__panel g-image-trio-edit__panel--arrow g-image-trio-edit__panel--float is-align-left"
								@click.stop
							>
								<div class="g-image-trio-edit__link-row">
									<i class="mbm-iconfont mbm-lianjie"></i>
									<span :class="{ 'is-empty': !jumpLinkLabel }">{{ jumpLinkLabel || '未设置链接' }}</span>
								</div>
								<div class="g-image-trio-edit__toolbar">
									<button type="button" class="g-image-trio-edit__action" @click="jumpLinkVisible = true">换链接</button>
									<button type="button" class="g-image-trio-edit__action" @click="triggerImageSelect">换图</button>
									<span class="g-image-trio-edit__action-wrap">
										<button
											type="button"
											class="g-image-trio-edit__action"
											:class="{ 'is-active': activePanel === 'radius' }"
											@click="togglePanel('radius')"
										>圆角</button>
										<div v-if="activePanel === 'radius'" class="g-image-trio-edit__sub-panel">
											<span class="g-image-trio-edit__sub-label">圆角 (px)</span>
											<a-input-number
												v-model:value="radiusDraft"
												:min="0"
												:max="40"
												:precision="0"
												class="g-image-trio-edit__sub-input"
											/>
											<button type="button" class="g-image-trio-edit__sub-confirm" @click="applyRadius">确定</button>
										</div>
									</span>
									<div class="g-image-trio-edit__colors">
										<ColorPicker
											v-model="form.items[0].titleColor"
											title="文字颜色"
											@change="color => onTitleColorInput(0, color)"
										/>
									</div>
								</div>
							</div>
						</div>

						<div class="g-image-trio-edit__side">
							<div
								v-for="index in [1, 2]"
								:key="form.items[index].id"
								class="g-image-trio-edit__cell-wrap g-image-trio-edit__cell-wrap--side"
								:class="{ 'is-active': selectedIndex === index }"
								@click.stop="selectItem(index)"
							>
								<div
									class="g-image-trio-edit__cell"
									:class="{ 'is-selected': selectedIndex === index }"
									:style="cellStyle"
								>
									<UploadProgressPanel
										v-if="isUploading && selectedIndex === index"
										:tasks="uploadTasks"
										variant="item"
										hide-filename
									/>
									<template v-else>
										<img v-if="getImageUrl(form.items[index])" :src="getImageUrl(form.items[index])" alt="" />
										<i v-else class="mbm-iconfont mbm-tupian"></i>
									</template>
									<input
										v-model="form.items[index].title"
										type="text"
										class="g-image-trio-edit__caption-input"
										:style="{ color: form.items[index].titleColor }"
										maxlength="20"
										placeholder="标题"
										@click.stop="selectItem(index)"
										@focus="selectItem(index)"
									/>
								</div>
								<div
									v-if="selectedIndex === index"
									class="g-image-trio-edit__panel g-image-trio-edit__panel--arrow g-image-trio-edit__panel--float is-align-right"
									@click.stop
								>
									<div class="g-image-trio-edit__link-row">
										<i class="mbm-iconfont mbm-lianjie"></i>
										<span :class="{ 'is-empty': !jumpLinkLabel }">{{ jumpLinkLabel || '未设置链接' }}</span>
									</div>
									<div class="g-image-trio-edit__toolbar">
										<button type="button" class="g-image-trio-edit__action" @click="jumpLinkVisible = true">换链接</button>
										<button type="button" class="g-image-trio-edit__action" @click="triggerImageSelect">换图</button>
										<span class="g-image-trio-edit__action-wrap">
											<button
												type="button"
												class="g-image-trio-edit__action"
												:class="{ 'is-active': activePanel === 'radius' }"
												@click="togglePanel('radius')"
											>圆角</button>
											<div v-if="activePanel === 'radius'" class="g-image-trio-edit__sub-panel">
												<span class="g-image-trio-edit__sub-label">圆角 (px)</span>
												<a-input-number
													v-model:value="radiusDraft"
													:min="0"
													:max="40"
													:precision="0"
													class="g-image-trio-edit__sub-input"
												/>
												<button type="button" class="g-image-trio-edit__sub-confirm" @click="applyRadius">确定</button>
											</div>
										</span>
										<div class="g-image-trio-edit__colors">
											<ColorPicker
												v-model="form.items[index].titleColor"
												title="文字颜色"
												@change="color => onTitleColorInput(index, color)"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<input
			ref="fileInput"
			type="file"
			accept="image/*"
			class="g-image-trio-edit__file-input"
			@change="onFileChange"
		/>

		<JumpLink
			:visible="jumpLinkVisible"
			:jumpLink="selectedItem?.jumpLink || emptyJumpLink"
			@submit="onJumpLinkSubmit"
			@cancel="jumpLinkVisible = false"
		/>

		<template #footer>
			<a-button @click="onCancel">取消</a-button>
			<a-button
				type="primary"
				class="g-image-trio-edit-modal__ok"
				:disabled="isUploading"
				@click="onConfirm"
			>确认</a-button>
		</template>
	</a-modal>
</template>

<script>
	import JumpLink from '@/components/jumpLink.vue';
	import ColorPicker from './ColorPicker.vue';
	import UploadProgressPanel from './UploadProgressPanel.vue';
	import { isLocalImageFile, MAX_LOCAL_IMAGE_SIZE } from '../utils/localImage.js';
	import { createEmptyJumpLink, formatJumpLinkLabel } from '../utils/jumpLink.js';
	import { normalizeHexColor } from '../utils/richText.js';
	import { ensureEditFloatPanelVisible } from '../utils/editPanelAlign.js';
	import {
		createUploadTasks,
		updateUploadTaskProgress,
		uploadHeaderMediaFiles,
	} from '../utils/uploadHeaderMedia.js';
	import {
		getImageTrioBlockStyle,
		getImageTrioImageUrl,
		IMAGE_TRIO_DEFAULT_RADIUS,
		normalizeImageTrioData,
		replaceImageTrioImage,
	} from '../utils/imageTrio.js';

	export default {
		name: 'GImageTrioEditModal',
		components: { JumpLink, ColorPicker, UploadProgressPanel },
		props: {
			visible: { type: Boolean, default: false },
			data: { type: Object, default: () => ({}) },
		},
		emits: ['update:visible', 'confirm'],
		data() {
			return {
				form: normalizeImageTrioData({}),
				selectedIndex: null,
				activePanel: '',
				radiusDraft: IMAGE_TRIO_DEFAULT_RADIUS,
				jumpLinkVisible: false,
				emptyJumpLink: createEmptyJumpLink(),
				isUploading: false,
				uploadTasks: [],
			};
		},
		computed: {
			selectedItem() {
				return this.form.items[this.selectedIndex] || null;
			},
			jumpLinkLabel() {
				return formatJumpLinkLabel(this.selectedItem?.jumpLink);
			},
			blockStyle() {
				return getImageTrioBlockStyle(this.form);
			},
			gridStyle() {
				return {
					gap: this.blockStyle.gap,
					'--trio-gap': this.blockStyle.gap,
				};
			},
			cellStyle() {
				return {
					borderRadius: this.blockStyle.borderRadius,
				};
			},
		},
		watch: {
			visible(val) {
				if (val) {
					this.selectedIndex = null;
					this.activePanel = '';
					this.jumpLinkVisible = false;
					this.syncForm();
				}
			},
			data: {
				deep: true,
				handler() {
					if (this.visible) this.syncForm();
				},
			},
		},
		methods: {
			syncForm() {
				this.form = normalizeImageTrioData(this.data);
				this.radiusDraft = this.form.borderRadius;
				if (this.selectedIndex != null && this.selectedIndex >= this.form.items.length) {
					this.selectedIndex = null;
				}
			},
			getImageUrl(item) {
				return getImageTrioImageUrl(item?.image);
			},
			ensureActivePanelVisible() {
				ensureEditFloatPanelVisible(this, {
					gridRef: 'editGrid',
					wrapSelector: '.g-image-trio-edit__cell-wrap',
					panelSelector: '.g-image-trio-edit__panel--float',
				});
			},
			selectItem(index) {
				this.selectedIndex = index;
				this.activePanel = '';
				this.ensureActivePanelVisible();
			},
			clearSelection() {
				this.selectedIndex = null;
				this.activePanel = '';
			},
			togglePanel(panel) {
				this.activePanel = this.activePanel === panel ? '' : panel;
				if (panel === 'radius') {
					this.radiusDraft = this.form.borderRadius;
				}
				if (this.activePanel) {
					this.$nextTick(() => this.ensureActivePanelVisible());
				}
			},
			applyRadius() {
				this.form.borderRadius = Math.max(0, Number(this.radiusDraft) || 0);
				this.activePanel = '';
			},
			onTitleColorInput(index, color) {
				const item = this.form.items[index];
				if (!item) return;
				item.titleColor = normalizeHexColor(color);
			},
			triggerImageSelect() {
				this.$refs.fileInput?.click();
			},
			async onFileChange(event) {
				const file = event.target.files?.[0];
				event.target.value = '';
				if (!file || !isLocalImageFile(file) || !this.selectedItem) return;
				if (file.size > MAX_LOCAL_IMAGE_SIZE) {
					this.$message?.error?.('图片过大');
					return;
				}
				this.isUploading = true;
				this.uploadTasks = createUploadTasks([file]);
				try {
					const [uploaded] = await uploadHeaderMediaFiles(this, {
						type: 'image',
						files: [file],
						onProgress: payload => updateUploadTaskProgress(this.uploadTasks, payload),
					});
					this.selectedItem.image = replaceImageTrioImage(
						this.selectedItem.image,
						file,
						() => uploaded,
					);
				} catch (error) {
					this.$message?.error?.('上传失败');
				} finally {
					this.isUploading = false;
					this.uploadTasks = [];
				}
			},
			onJumpLinkSubmit(link) {
				if (this.selectedItem) {
					this.selectedItem.jumpLink = link?.type ? { ...link } : null;
				}
				this.jumpLinkVisible = false;
			},
			onCancel() {
				this.$emit('update:visible', false);
			},
			onConfirm() {
				const payload = normalizeImageTrioData({
					...this.form,
					items: this.form.items.map(item => ({
						...item,
						title: item.title?.trim() || '',
					})),
				});
				this.$emit('confirm', payload);
				this.$emit('update:visible', false);
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../styles/edit-float-panel.less';

	.edit-float-panel(g-image-trio-edit__panel);
	.edit-float-toolbar(g-image-trio-edit__toolbar);
	.edit-float-action(g-image-trio-edit__action);

	.g-image-trio-edit {
		padding: 8px 0 24px;
	}

	.g-image-trio-edit__stage {
		width: 100%;
		max-width: 560px;
		margin: 0 auto;
	}

	.g-image-trio-edit__grid {
		display: flex;
		align-items: stretch;
		width: 100%;
	}

	.g-image-trio-edit__cell-wrap {
		position: relative;
		min-width: 0;
		min-height: 0;

		&--main {
			flex: 1.05 1 0;
			aspect-ratio: 1 / 1;
		}

		&--side {
			flex: 1 1 0;
		}
	}

	.g-image-trio-edit__side {
		flex: 1 1 0;
		min-width: 0;
		display: flex;
		flex-direction: column;
		gap: var(--trio-gap, 8px);
	}

	.g-image-trio-edit__cell {
		position: relative;
		width: 100%;
		height: 100%;
		overflow: hidden;
		background: #f0f0f0;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		box-sizing: border-box;
		border: 2px solid transparent;

		&.is-selected {
			border-style: dashed;
			border-color: #52c41a;
		}

		img {
			display: block;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		i {
			font-size: 28px;
			color: #bfbfbf;
		}

		&::after {
			content: '';
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
			height: 40%;
			background: linear-gradient(transparent, rgba(0, 0, 0, 0.35));
			pointer-events: none;
		}
	}

	.g-image-trio-edit__caption-input {
		position: absolute;
		left: 10px;
		right: 10px;
		bottom: 10px;
		z-index: 2;
		border: none;
		outline: none;
		background: transparent;
		padding: 0;
		font-size: 13px;
		font-weight: 500;
		line-height: 1.3;
		color: #fff;
		text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);

		&::placeholder {
			color: rgba(255, 255, 255, 0.7);
		}

		&--main {
			font-size: 15px;
		}
	}

	.g-image-trio-edit__link-row {
		display: flex;
		align-items: center;
		gap: 8px;
		min-height: 40px;
		padding: 0 14px;
		border-bottom: 1px solid #f0f0f0;
		font-size: 13px;
		color: #333;
		white-space: nowrap;

		i {
			color: #999;
			font-size: 14px;
		}

		.is-empty {
			color: #999;
		}
	}

	.g-image-trio-edit__action-wrap {
		position: relative;
		display: inline-flex;
	}

	.g-image-trio-edit__sub-panel {
		position: absolute;
		top: calc(100% + 8px);
		left: 50%;
		transform: translateX(-50%);
		z-index: 2;
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 10px 12px;
		background: #fff;
		border: 1px solid #eceef2;
		border-radius: 8px;
		box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
		white-space: nowrap;
	}

	.g-image-trio-edit__sub-label {
		font-size: 12px;
		color: #666;
	}

	.g-image-trio-edit__sub-input {
		width: 80px;
	}

	.g-image-trio-edit__sub-confirm {
		height: 28px;
		padding: 0 10px;
		border: none;
		border-radius: 4px;
		background: #285af9;
		color: #fff;
		font-size: 12px;
		cursor: pointer;
	}

	.g-image-trio-edit__colors {
		display: inline-flex;
		align-items: center;
		gap: 8px;
		margin-left: 4px;
	}

	.g-image-trio-edit__file-input {
		display: none;
	}
</style>

<style lang="less">
	@import '../styles/edit-float-panel.less';

	.g-image-trio-edit-modal {
		.edit-modal-body();
		.edit-modal-scroll();

		.g-image-trio-edit-modal__ok {
			min-width: 72px;
		}
	}
</style>
